import { useTranslation } from "react-i18next";
import { Col, Input, Label, Row } from "reactstrap";
import Select from "react-select";
import SelectCustomStyles from "../../../../../utils/styles/reactSelect";

function TimeManagementTab({ employeeData, setEmployeeData }) {
  const { t } = useTranslation();

  const absenceTypesOptions = [
    { value: 'sick-leave', label: t('hr.sickLeave') },
    { value: 'authorized-leave', label: t('hr.authorizedLeave') },
    { value: 'unauthorized-leave', label: t('hr.unauthorizedLeave') },
    { value: 'annual-leave', label: t('hr.annualLeave') },
    { value: 'long-term-sick-leave', label: t('hr.longTermSickLeave') },
    { value: 'maternity-leave', label: t('hr.maternityLeave') },
    { value: 'paternity-leave', label: t('hr.paternityLeave') },
    { value: 'marriage-leave', label: t('hr.marriageLeave') },
    { value: 'bereavement-leave', label: t('hr.bereavementLeave') },
    { value: 'unpaid-leave', label: t('hr.unpaidLeave') },
    { value: 'training-study-leave', label: t('hr.trainingStudyLeave') }
  ];

  return(
    <>
      <Row>
        <Col md="4" className="mb-3">
          <Label>{t('hr.shiftType')} </Label>
          <Input 
            type="text" 
            value={employeeData.shift_type || ''} 
            onChange={(e) => setEmployeeData({ ...employeeData, shift_type: e.target.value })} 
          />
        </Col>
      </Row>
      <Row>
        <Col md="4" className="mb-3">
          <Label>{t('hr.absenceTypesNotAllowed')} </Label>
          <Select
            value={absenceTypesOptions.filter(option => employeeData.absence_types_not_allowed?.includes(option.value))}
            onChange={(selectedOptions) => setEmployeeData({ ...employeeData, absence_types_not_allowed: selectedOptions.map(option => option.value) })}
            options={absenceTypesOptions}
            styles={SelectCustomStyles}
            isMulti
          />
        </Col>
      </Row>

      <Row>
        <Col md="4" className="mb-2 d-flex align-items-center">
          <Input 
            type="checkbox" 
            className="mt-0" 
            checked={employeeData.overtime_allowed || false} 
            onChange={(e) => setEmployeeData({ ...employeeData, overtime_allowed: e.target.checked })} 
          />
          <Label className="ms-1 mb-0">{t('hr.overtimeAllowed')} </Label>
        </Col>
      </Row>

      {employeeData.overtime_allowed && 
        <Row className="g-3">
          <Col md="4">
            <Label>{t('hr.overtimeType')} </Label>
            <Input type="select" value={employeeData.overtime_type || ''} onChange={(e) => setEmployeeData({ ...employeeData, overtime_type: e.target.value })}>
              <option value="hourly">{t('hr.hourly')}</option>
              <option value="daily">{t('hr.daily')}</option>
            </Input>
          </Col>
          <Col md="4">
            <Label>{t('hr.overtimeRate')} </Label>
            <Input 
              type="text" 
              value={employeeData.overtime_rate || ''} 
              onChange={(e) => setEmployeeData({ ...employeeData, overtime_rate: e.target.value })} 
              placeholder="150%" 
            />
          </Col>
        </Row>
      }
    </>
  );
}

export default TimeManagementTab;
